import { FireOutbreakReactionEnum } from '../../../../@core/fire-risk-dashboard/domain/enum/FireOutbreakReaction.enum'
import { FireOutbreakReaction } from './FireOutbreakReaction.abstract'

export class CantRelateFireOutbreakOptionStrategy extends FireOutbreakReaction {
	constructor() {
		super('Indeterminado', 'fa7-solid:question', FireOutbreakReactionEnum.IMPOSSIBLE)
	}
}
